<a class="goback-pane" [routerLink]="path" [queryParams]="queryParams">
  <span class="goback normal">← {{ 'library.titles.goback' | customLocale }}</span>
</a>
